import { Component } from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatError, MatFormField, MatLabel} from "@angular/material/form-field";
import {MatIcon} from "@angular/material/icon";
import {MatInput} from "@angular/material/input";
import {MatButton, MatIconButton} from "@angular/material/button";
import {AuthService} from "../../../services/auth.service";
import {firstError} from "../../../helper/first-error";
import {NgClass, NgIf} from "@angular/common";
import {NgxCaptchaModule, ReCaptchaV3Service} from "ngx-captcha";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-sign-in',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatIcon,
    MatInput,
    MatIconButton,
    MatButton,
    MatError,
    NgIf,
    NgClass,
    NgxCaptchaModule,
  ],
  templateUrl: './sign-in.component.html',
  styleUrl: './sign-in.component.scss'
})
export class SignInComponent {

  firstTime = true;
  step = 1;
  authForm = new FormGroup({
    login: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
  });

  authForm2 = new FormGroup({
    code: new FormControl('', [Validators.required]),
  });

  authForm3 = new FormGroup({
    login: new FormControl('', [Validators.required]),
  });

  authForm4 = new FormGroup({
    code: new FormControl('', [Validators.required]),
  });


  constructor(protected authService: AuthService,
              private reCaptchaV3Service: ReCaptchaV3Service) {
    const tm =setTimeout(() => {
      this.firstTime = false;
      clearTimeout(tm);
    }, 3000);
  }


  clear(field: 'login' | 'password') {
    this.authForm.controls[field]?.patchValue('');
  }
  clear2(field: 'code') {
    this.authForm2.controls[field]?.patchValue('');
  }
  clear3(field: 'login') {
    this.authForm3.controls[field]?.patchValue('');
  }
  clear4(field: 'code') {
    this.authForm4.controls[field]?.patchValue('');
  }

  sendForm1(eve: Event) {
    eve.preventDefault();

    this.reCaptchaV3Service.execute(environment.recapKey, 'homepage', (token: string) => {

      if (this.authForm.valid) {
        this.authService.signIn(this.authForm.value.login || '', this.authForm.value.password || '', token)
          .then(auth => {
            if (!auth) {
              this.authForm.controls.login.setErrors({login: 'No User Found'})
            } else {
              localStorage.setItem('jwtToken', (auth as {token: string}).token);
              this.step = 2;
            }
          })
          .catch(console.error);
      }

    }, {
      useGlobalDomain: false
    });

  }

  sendForm2(eve: Event) {
    eve.preventDefault();

    if (this.authForm2.valid) {
      this.authService.singInFinal(this.authForm2.value.code || '')
        .then(auth => {
          if (!auth) {
            this.authForm2.controls.code.setErrors({login: 'Not a valid code'})
          } else {
            localStorage.setItem('jwtToken', (auth as {token: string}).token);
          }
        })
        .catch(console.error);
    }
  }

  sendForm3(eve: Event) {
    eve.preventDefault();

    if (this.authForm3.valid) {
      this.authService.reset(this.authForm3.value.login || '')
        .then(auth => {
          if (!auth) {
            this.authForm3.controls.login.setErrors({login: 'No User Found'})
          } else {
            this.step = 4;
          }
        })
        .catch(console.error);
    }
  }

  sendForm4(eve: Event) {
    eve.preventDefault();

    if (this.authForm4.valid) {
      this.authService.nwPassword(this.authForm4.value.code || '')
        .then(auth => {
          if (!auth) {
            this.authForm4.controls.code.setErrors({login: 'No User Found'})
          } else {
            this.step = 1;
          }
        })
        .catch(console.error);
    }
  }

  reset() {
    this.step = 3;
  }

  back() {
    this.step = 1;
  }

  protected readonly firstError = firstError;
}
